//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from "@environments/environment";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class Foo {
  protected getBaseUrl(deaultUrl: string): string {
    return environment.remoteServiceBaseUrl;
  }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationServiceProxy extends Foo {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    getAll(): Observable<OrganizationForOwnerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Organization/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationForOwnerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationForOwnerDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationForOwnerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationForOwnerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rename(body: RenameDto | undefined): Observable<OrganizationForOwnerDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRename(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationForOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationForOwnerDto>;
        }));
    }

    protected processRename(response: HttpResponseBase): Observable<OrganizationForOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationForOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    inviteUsersByEmail(body: InviteUsersByEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/InviteUsersByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteUsersByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteUsersByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInviteUsersByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    removeUser(organizationId: string | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/RemoveUser?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelInvitation(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/CancelInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    leaveOrganization(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/LeaveOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLeaveOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSessionUserLanguage(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Organization/GetSessionUserLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSessionUserLanguage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CalendarAvailability implements ICalendarAvailability {
    individual!: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating!: { [key: string]: TimeRange[]; } | undefined;

    constructor(data?: ICalendarAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["individual"]) {
                this.individual = {} as any;
                for (let key in _data["individual"]) {
                    if (_data["individual"].hasOwnProperty(key))
                        (<any>this.individual)![key] = _data["individual"][key] ? _data["individual"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["weeklyRepeating"]) {
                this.weeklyRepeating = {} as any;
                for (let key in _data["weeklyRepeating"]) {
                    if (_data["weeklyRepeating"].hasOwnProperty(key))
                        (<any>this.weeklyRepeating)![key] = _data["weeklyRepeating"][key] ? _data["weeklyRepeating"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CalendarAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.individual) {
            data["individual"] = {};
            for (let key in this.individual) {
                if (this.individual.hasOwnProperty(key))
                    (<any>data["individual"])[key] = (<any>this.individual)[key];
            }
        }
        if (this.weeklyRepeating) {
            data["weeklyRepeating"] = {};
            for (let key in this.weeklyRepeating) {
                if (this.weeklyRepeating.hasOwnProperty(key))
                    (<any>data["weeklyRepeating"])[key] = (<any>this.weeklyRepeating)[key];
            }
        }
        return data;
    }
}

export interface ICalendarAvailability {
    individual: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating: { [key: string]: TimeRange[]; } | undefined;
}

export class CreateDto implements ICreateDto {
    name!: string | undefined;

    constructor(data?: ICreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDto {
    name: string | undefined;
}

export class GuidEntityDto implements IGuidEntityDto {
    id!: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGuidEntityDto {
    id: string;
}

export class InviteUsersByEmailInput implements IInviteUsersByEmailInput {
    emails!: string[] | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IInviteUsersByEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): InviteUsersByEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUsersByEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IInviteUsersByEmailInput {
    emails: string[] | undefined;
    captchaResponse: string | undefined;
}

export class OrganizationForOwnerDto implements IOrganizationForOwnerDto {
    id!: string;
    name!: string | undefined;
    organizationInvitations!: OrganizationInvitationDto[] | undefined;
    userOrganizations!: OrganizationMemberDto[] | undefined;
    seatsTaken!: number;
    isAdmin!: boolean;

    constructor(data?: IOrganizationForOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.organizationInvitations) {
                this.organizationInvitations = [];
                for (let i = 0; i < data.organizationInvitations.length; i++) {
                    let item = data.organizationInvitations[i];
                    this.organizationInvitations[i] = item && !(<any>item).toJSON ? new OrganizationInvitationDto(item) : <OrganizationInvitationDto>item;
                }
            }
            if (data.userOrganizations) {
                this.userOrganizations = [];
                for (let i = 0; i < data.userOrganizations.length; i++) {
                    let item = data.userOrganizations[i];
                    this.userOrganizations[i] = item && !(<any>item).toJSON ? new OrganizationMemberDto(item) : <OrganizationMemberDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["organizationInvitations"])) {
                this.organizationInvitations = [] as any;
                for (let item of _data["organizationInvitations"])
                    this.organizationInvitations!.push(OrganizationInvitationDto.fromJS(item));
            }
            if (Array.isArray(_data["userOrganizations"])) {
                this.userOrganizations = [] as any;
                for (let item of _data["userOrganizations"])
                    this.userOrganizations!.push(OrganizationMemberDto.fromJS(item));
            }
            this.seatsTaken = _data["seatsTaken"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): OrganizationForOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationForOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.organizationInvitations)) {
            data["organizationInvitations"] = [];
            for (let item of this.organizationInvitations)
                data["organizationInvitations"].push(item.toJSON());
        }
        if (Array.isArray(this.userOrganizations)) {
            data["userOrganizations"] = [];
            for (let item of this.userOrganizations)
                data["userOrganizations"].push(item.toJSON());
        }
        data["seatsTaken"] = this.seatsTaken;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IOrganizationForOwnerDto {
    id: string;
    name: string | undefined;
    organizationInvitations: IOrganizationInvitationDto[] | undefined;
    userOrganizations: IOrganizationMemberDto[] | undefined;
    seatsTaken: number;
    isAdmin: boolean;
}

export class OrganizationInvitationDto implements IOrganizationInvitationDto {
    id!: string;
    inviterId!: number;
    inviterSurname!: string | undefined;
    inviterName!: string | undefined;
    email!: string | undefined;
    isRejected!: boolean;
    isAccepted!: boolean;
    isDeleted!: boolean;
    creationTime!: Date;

    constructor(data?: IOrganizationInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inviterId = _data["inviterId"];
            this.inviterSurname = _data["inviterSurname"];
            this.inviterName = _data["inviterName"];
            this.email = _data["email"];
            this.isRejected = _data["isRejected"];
            this.isAccepted = _data["isAccepted"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationInvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inviterId"] = this.inviterId;
        data["inviterSurname"] = this.inviterSurname;
        data["inviterName"] = this.inviterName;
        data["email"] = this.email;
        data["isRejected"] = this.isRejected;
        data["isAccepted"] = this.isAccepted;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationInvitationDto {
    id: string;
    inviterId: number;
    inviterSurname: string | undefined;
    inviterName: string | undefined;
    email: string | undefined;
    isRejected: boolean;
    isAccepted: boolean;
    isDeleted: boolean;
    creationTime: Date;
}

export class OrganizationMemberDto implements IOrganizationMemberDto {
    id!: string;
    creationTime!: Date;
    userId!: number;
    userTimezone!: string | undefined;
    userEmailAddress!: string | undefined;
    userUserName!: string | undefined;
    userName!: string | undefined;
    userTenantId!: number;
    userIsDeleted!: boolean;
    isDeleted!: boolean;
    userSurname!: string | undefined;
    userCalendarAvailability!: CalendarAvailability;
    isAdmin!: boolean;
    hasZoomIngration!: boolean;
    hasGoogleMeetIngration!: boolean;
    hasMicrosoftTeamMeetingIntegration!: boolean;
    isPremium!: boolean;

    constructor(data?: IOrganizationMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userCalendarAvailability = data.userCalendarAvailability && !(<any>data.userCalendarAvailability).toJSON ? new CalendarAvailability(data.userCalendarAvailability) : <CalendarAvailability>this.userCalendarAvailability;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userTimezone = _data["userTimezone"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userUserName = _data["userUserName"];
            this.userName = _data["userName"];
            this.userTenantId = _data["userTenantId"];
            this.userIsDeleted = _data["userIsDeleted"];
            this.isDeleted = _data["isDeleted"];
            this.userSurname = _data["userSurname"];
            this.userCalendarAvailability = _data["userCalendarAvailability"] ? CalendarAvailability.fromJS(_data["userCalendarAvailability"]) : <any>undefined;
            this.isAdmin = _data["isAdmin"];
            this.hasZoomIngration = _data["hasZoomIngration"];
            this.hasGoogleMeetIngration = _data["hasGoogleMeetIngration"];
            this.hasMicrosoftTeamMeetingIntegration = _data["hasMicrosoftTeamMeetingIntegration"];
            this.isPremium = _data["isPremium"];
        }
    }

    static fromJS(data: any): OrganizationMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userTimezone"] = this.userTimezone;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userUserName"] = this.userUserName;
        data["userName"] = this.userName;
        data["userTenantId"] = this.userTenantId;
        data["userIsDeleted"] = this.userIsDeleted;
        data["isDeleted"] = this.isDeleted;
        data["userSurname"] = this.userSurname;
        data["userCalendarAvailability"] = this.userCalendarAvailability ? this.userCalendarAvailability.toJSON() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        data["hasZoomIngration"] = this.hasZoomIngration;
        data["hasGoogleMeetIngration"] = this.hasGoogleMeetIngration;
        data["hasMicrosoftTeamMeetingIntegration"] = this.hasMicrosoftTeamMeetingIntegration;
        data["isPremium"] = this.isPremium;
        return data;
    }
}

export interface IOrganizationMemberDto {
    id: string;
    creationTime: Date;
    userId: number;
    userTimezone: string | undefined;
    userEmailAddress: string | undefined;
    userUserName: string | undefined;
    userName: string | undefined;
    userTenantId: number;
    userIsDeleted: boolean;
    isDeleted: boolean;
    userSurname: string | undefined;
    userCalendarAvailability: ICalendarAvailability;
    isAdmin: boolean;
    hasZoomIngration: boolean;
    hasGoogleMeetIngration: boolean;
    hasMicrosoftTeamMeetingIntegration: boolean;
    isPremium: boolean;
}

export class RenameDto implements IRenameDto {
    id!: string;
    name!: string | undefined;

    constructor(data?: IRenameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameDto {
    id: string;
    name: string | undefined;
}

export class Time implements ITime {
    hours!: number;
    minutes!: number;

    constructor(data?: ITime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): Time {
        data = typeof data === 'object' ? data : {};
        let result = new Time();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITime {
    hours: number;
    minutes: number;
}

export class TimeRange implements ITimeRange {
    start!: Time;
    end!: Time;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.start = data.start && !(<any>data.start).toJSON ? new Time(data.start) : <Time>this.start;
            this.end = data.end && !(<any>data.end).toJSON ? new Time(data.end) : <Time>this.end;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? Time.fromJS(_data["start"]) : <any>undefined;
            this.end = _data["end"] ? Time.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    start: ITime;
    end: ITime;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}